import { render, staticRenderFns } from "./update_training.vue?vue&type=template&id=2330b4a6&scoped=true&"
import script from "./update_training.vue?vue&type=script&lang=js&"
export * from "./update_training.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2330b4a6",
  null
  
)

export default component.exports